<div class="view overlay zoom">

  <img [src]="sanitizer.bypassSecurityTrustUrl(image)" class="img-fluid" style="width: 100%;height: 510px" alt="Sample image with waves effect.">

</div>